import Container from "@/components/common/Container";
import PrimaryButton from "@/components/common/PrimaryButton";
import { LINK_OF_ALL_PAGES } from "const/common";
import VerticalTab from "./VerticalTab";

const ServicesExpertise = (data) => {
  const { tabData, title, description } = data.servicesExpertise;
  return (
    <Container large className="py-20 lg:py-40">
      <VerticalTab description={description} tabData={tabData} title={title} />
      <div className="flex justify-center mx-auto pt-4 md:pt-16 lg:pt-20">
        <PrimaryButton
          link={LINK_OF_ALL_PAGES.mainPages.contactUs}
          val="Get in Touch"
          className="w-fit h-fit py-3 px-7 md:py-2 md:px-5 lg:py-4 lg:px-10"
        />
      </div>
    </Container>
  );
};
export default ServicesExpertise;
